import React, {useState} from 'react';
import {useApiReadStudentLessonFilters} from "@/api/lesson";
import RenderIf from "@/components/render-if";
import {Alert, Spin} from "antd";
import StudentLayout from "@/components/layout/student/studentLayout";
import {URLS} from "@/lib/urls";
import AgeMessage from "@/components/age/age-message";
import {useNavigate} from "react-router-dom";
import {APP_CLIENT} from "@/constants/config";
import QuranLoveGradeList from "@/pages/student/lessons/steps/_section/QuranLoveGradeList";


function ChooseGradePage(props) {

    return (
        <>
            <StudentLayout pageTitle={'انتخاب مقطع تحصیلی'} backTo={URLS.student.dashboard}>
                <GradeSelectBox/>
            </StudentLayout>
        </>
    );
}

export default ChooseGradePage;

export function GradeSelectBox(props) {
    const [myGrade, setMyGrade] = useState(null)
    const navigate = useNavigate()
    const {data: filtersData, isPending, isSuccess} = useApiReadStudentLessonFilters();
    return (
        <>
            <RenderIf condition={isPending}>
                <Spin spinning={true}/>
            </RenderIf>
            <RenderIf condition={isSuccess}>

                <RenderIf condition={APP_CLIENT === 'quranlove' || APP_CLIENT === 'edu'}>

                    <div className="grid grid-cols-1 items-stretch gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                        {filtersData?.data?.data?.grades
                            .sort((a, b) => (a.sort || 999) - (b.sort || 999))
                            .map(item => (
                                <QuranLoveGradeList key={item.id + 'grade-choose-quranlove'} grade={item}
                                />
                            ))}
                    </div>


                </RenderIf>
                <RenderIf condition={APP_CLIENT !== 'quranlove' && APP_CLIENT !== 'edu'}>
                    <Alert type="success" className={'mb-2'} description={'لطفا مقطع تحصیلی خود را انتخاب کنید'}>

                    </Alert>
                    {filtersData?.data?.data?.grades.map((item, i) => (
                        <div key={item.id + 'grade-choose' + i} className={'m-2'}>
                            <EducationCard {...item} onClick={() => {
                                navigate(URLS.student.lessons.take + '?grade_id=' + item.id, {})
                            }}/>
                        </div>

                    ))}
                </RenderIf>

            </RenderIf>
        </>)
}


const EducationCard = ({title, description, minage, maxage, minagedate, maxagedate, onClick}) => {
    return (
        <div
            onClick={onClick}
            className="group bg-white rounded-2xl shadow-md hover:shadow-2xl hover:scale-[1.01] transition-all duration-300 cursor-pointer overflow-hidden border border-gray-100 dark:border-gray-600 hover:border-indigo-200"
        >
            <div className="p-5 flex flex-col justify-between h-full">
                <div>
                    <h3 className="text-lg font-semibold   mb-2 group-hover:text-indigo-600 transition-colors duration-300">
                        {title}
                    </h3>
                    <p className="text-gray-500 text-sm mb-3">{description}</p>
                </div>
                <div className="text-sm font-medium text-indigo-600 bg-indigo-50 px-3 py-2 rounded-xl text-center">
                    <AgeMessage
                        minage={minage}
                        maxage={maxage}
                        minagedate={minagedate}
                        maxagedate={maxagedate}
                    />
                </div>
            </div>
        </div>
    );
};